<div fxLayout="column" fxLayoutGap="16px" style="margin-bottom: 24px">
  <h2 class="margin-bottom-32">What does this tax apply to?</h2>

  <div>
    <div fxFlexFill fxLayout="column">
      <ng-container *ngFor="let rate of definedPercentageRates">
        <div fxLayout fxLayoutGap="4px" fxLayoutAlign="start center">
          <mat-checkbox
            [checked]="tax.subjects.indexOf(rate.key) > -1"
            (change)="onSelectRate($event, rate)"
            [value]="rate.key">
            <span fxLayout fxLayoutGap="8px" fxLayoutAlign="start center">
              <span fxFlex>{{ rate.label }}</span>
            </span>
          </mat-checkbox>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div style="margin-top: 32px" fxLayout fxLayoutGap="24px" fxLayoutAlign="end center">
  <sbnb-button
    data-intercom-target="direct-add-tax-setup-back"
    label="Back"
    type="secondary"
    (click)="back()"></sbnb-button>

  <sbnb-button
    [disabled]="!tax.subjects || tax.subjects.length === 0"
    data-intercom-target="direct-add-tax-setup-save"
    label="Continue"
    (clicked)="progress()"></sbnb-button>
</div>
